// ===============================
// RESET VARIANTS
// ===============================
// Alleen waar de template dit vraagt (siliconen: vinkje 'Klant moet zelf maat kiezen').
// Stof en QR hebben geen maat en houden de standaard-selectie van Dawn.
document.querySelectorAll('variant-selects[data-require-choice] input[type="radio"]').forEach(radio => {
  radio.checked = false;
  radio.removeAttribute('checked');
});

// ===============================
// GLOBAL STATE
// ===============================
let lastFocusedInput = null;
let lastInputWasKeyboard = false;

// Track keyboard only when typing inside the silicone inputs
document.addEventListener('keydown', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastInputWasKeyboard = true;
    /* Te lang-melding: zie assets/gravure-limiet.js */
  }
});

// Track mouse down only on silicone inputs
document.addEventListener('mousedown', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastInputWasKeyboard = false;
  }
});

// Track focused input globally, but only save it if it's a silicone field
document.addEventListener('focusin', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastFocusedInput = t;
  }
});

// Track clicked input globally, but only save it if it's a silicone field
document.addEventListener('click', (e) => {
  const t = e.target;
  if (t && t.tagName === 'INPUT' && (t.id.startsWith('silicone-text') || t.id.startsWith('fabric-text') || t.id.startsWith('qr-text-input'))
) {
    lastFocusedInput = t;
  }
});

// ===============================
// SILICONE INPUTS SETUP
// ===============================
const siliconeInputs = [
  document.getElementById('silicone-text-1'),
  document.getElementById('silicone-text-2'),
  document.getElementById('fabric-text-icons-1-no-qr'),
  document.getElementById('fabric-text-line-1-no-qr'),
  document.getElementById('fabric-text-line-2-no-qr'),
  document.getElementById('fabric-text-line-3-no-qr'),
  document.getElementById('fabric-text-line-4-no-qr'),
  document.getElementById('qr-text-input')
].filter(Boolean);

const siliconeLabels = [
  document.querySelector('label[for="silicone-text-1"]'),
  document.querySelector('label[for="silicone-text-2"]')
].filter(Boolean);

if (siliconeInputs.length > 0) {
  lastFocusedInput = siliconeInputs[0];
}

// ===============================
// CHECK PRODUCT TYPE
// ===============================
function isSiliconeProduct() {
  const mainEl = document.getElementById('MainContent');
  const productTemplate = mainEl?.getAttribute('product-template');
  
  
  // Ab ye Silicone aur Kidscord dono ko accept kare ga
  return productTemplate && (
    productTemplate.startsWith('product.silicone') || 
    productTemplate.startsWith('product.kidscord')
  );
}

// ===============================
// INPUT HANDLER (MAIN LOGIC & SANITIZATION)
// ===============================
function handleSiliconeInput(e) {
  const input = e.target;
  const maxLength = parseInt(input.getAttribute("maxlength"), 10) || 16;
  let text = input.value;
  const originalText = text;


  // ===============================
  // 1. SANITIZE (ANSI + STORE ICONS ONLY)
  // ===============================
  
  // A. Greek Homoglyph Swap (Μ -> M)
  const lookalikes = {
    'Α': 'A', 'Β': 'B', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Ι': 'I', 
    'Κ': 'K', 'Μ': 'M', 'Ν': 'N', 'Ο': 'O', 'Ρ': 'P', 'Τ': 'T', 
    'Υ': 'Y', 'Χ': 'X'
  };
  text = text.replace(/[ΑΒΕΖΗΙΚΜΝΟΡΤΥΧ]/g, char => lookalikes[char]);

  // B. Build Whitelist of Official Store Icons
  const allowedIcons = new Set();
  document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(btn => {
    const val = btn.dataset.value || btn.textContent.trim();
    if (val) { for (const char of val) allowedIcons.add(char); }
  });

  // C. Strict Windows-1252 Regex (Tests a single character)
  const win1252Regex = /^[\x00-\xFF\u20AC\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\u017D\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\u017E\u0178]$/;

  // D. Filter the string character by character
  let cleanText = "";
  for (const char of text) {
    if (win1252Regex.test(char) || allowedIcons.has(char)) {
      cleanText += char;
    }
  }

  // E. Apply clean text and show warning if bad characters were removed
  if (cleanText !== originalText) {
    input.value = cleanText;
    input.style.border = "2px solid red";
    setTimeout(() => { input.style.border = ""; }, 2000);
  }

// ===============================
  // 2. SAFE UPPERCASE (OS MENU & KEYBOARD)
  // ===============================
  if (input.classList.contains('force-uppercase')) {
    const start = input.selectionStart;
    const end = input.selectionEnd;
    
    // Matches a-z and safe accented characters (Ä, Ö, Ü, etc.)
    // We EXPLICITLY EXCLUDE characters used for your custom icons (ò, ý, ð, ø, þ, æ, å, ÿ) 
    // so that the icons do not break when inserted.
    const safeUpperRegex = /[a-zàáâãäèéêëìíîïñóôõöùúûüß]/g;
    
    const newValue = input.value.replace(safeUpperRegex, char => {
      if (char === 'ß') return 'SS'; // Standard German uppercase conversion for ß
      return char.toUpperCase();
    });

    if (newValue !== input.value) {
        input.value = newValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        try { input.setSelectionRange(start, end); } catch (err) {}
    }
  }

  // ===============================
  // 3. MAX LENGTH & VISUAL FEEDBACK
  // ===============================
  // Niet meer afkappen: typen/plakken stopt vanzelf bij maxlength (= limiet + 2).
  // Is de tekst langer (bv. na kiezen van een kleinere maat), dan blijft hij staan
  // en blokkeert gravure-limiet.js de winkelwagenknop met een duidelijke melding.
  if (window.gravureLimiet) window.gravureLimiet.check(input);

  // Reset flag after processing
  lastInputWasKeyboard = false;
}

// ===============================
// ATTACH INPUT EVENTS
// ===============================
if (isSiliconeProduct()) {
  siliconeInputs.forEach(input => {

    input.addEventListener('input', handleSiliconeInput);

    input.addEventListener('focus', function() {
      lastFocusedInput = this;
    });
  });
}

// ===============================
// ICON INSERTION
// ===============================

const excludedIconInputs = [
  'fabric-text-line-1-no-qr',
  'fabric-text-line-2-no-qr',
  'fabric-text-line-3-no-qr',
  'fabric-text-line-4-no-qr'
];

document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(button => {
  button.type = "button";

  button.addEventListener('click', function (event) {
    event.preventDefault();

    const value = button.dataset.value || button.textContent.trim();

    if (!value) return;

    // Doelveld: het laatst gekozen icoonveld. Is dat er niet (meer), verborgen,
    // of een tekst-only regel, dan automatisch regel 1 van hetzelfde formulier.
    const isUsable = (el) => el && el.isConnected && !el.disabled && !el.readOnly &&
      el.offsetParent !== null && !excludedIconInputs.includes(el.id);
    let target = lastFocusedInput;
    if (!isUsable(target)) {
      const scope = button.closest('.product__custom-fields, form, product-form') || document;
      target = ['#silicone-text-1', '#fabric-text-icons-1-no-qr', '#qr-text-input']
        .map((sel) => scope.querySelector(sel))
        .find(isUsable) || null;
      if (target) lastFocusedInput = target;
    }
    if (!target) return;

    // ❗ IMPORTANT
    lastInputWasKeyboard = false;

    insertAtCaret(target, value);

    if (window.gravureLimiet) window.gravureLimiet.check(target);

    // target.dispatchEvent(new Event('input', { bubbles: true }));

    try { target.focus(); } catch (e) {}
  });
});

// ===============================
// INSERT FUNCTION
// ===============================
function insertAtCaret(target, text) {
  try {
    const supportsSelection = typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number';
    
    // --- FIXED: Get max from attribute ---
    const maxAttr = target.getAttribute("maxlength");
    const max = maxAttr ? parseInt(maxAttr, 10) : 16;

    if (supportsSelection) {
      const start = target.selectionStart;
      const end = target.selectionEnd;
      const before = target.value.slice(0, start);
      const after = target.value.slice(end);

      let insertText = text;
      // Calculate how much space is actually left
      const available = Math.max(0, max - (before.length + after.length));
      
      if (available <= 0) return; // Don't insert anything if full
      if (insertText.length > available) insertText = insertText.slice(0, available);

      target.value = before + insertText + after;
      const newPos = start + insertText.length;
      target.setSelectionRange(newPos, newPos);
    } else {
      let appendText = text;
      const available = Math.max(0, max - target.value.length);
      if (available <= 0) return;
      if (appendText.length > available) appendText = appendText.slice(0, available);
      target.value += appendText;
    }
  } catch (err) {
    console.error("Insert error:", err);
  }
}

// ===============================
// SIZE BASED MAX LENGTH
// ===============================
// ===============================
// SIZE BASED MAX LENGTH (UPDATED & SYNCED)
// ===============================
function updateSiliconeUI() {

  const activeInput = document.querySelector('.product-form__input--pill input:checked, .product-form__input input:checked');
  
  if (!activeInput) return;

  const val = activeInput.value;
  const mainDiv = document.querySelector(".live-preview-overlay");

  let newLength = 16;

  if (val.includes('13')) newLength = mainDiv.getAttribute('size-13') || 16;
  else if (val.includes('14')) newLength = mainDiv.getAttribute('size-14') || 16;
  else if (val.includes('15')) newLength = mainDiv.getAttribute('size-15') || 16;
  else if (val.includes('16')) newLength = mainDiv.getAttribute('size-16') || 16;
  else if (val.includes('18')) newLength = mainDiv.getAttribute('size-18') || 18;
  else if (val.includes('20')) newLength = mainDiv.getAttribute('size-20') || 20;

  siliconeLabels.forEach(label => {
    if (label) {
      label.textContent = label.textContent.replace(/\b[1-9][0-9]\b/, newLength);
    }
  });

  // Alleen de siliconen-velden hebben een maatafhankelijke limiet.
  // Tekst wordt NIET meer ingekort: te lang = rode melding + knop geblokkeerd (gravure-limiet.js).
  siliconeInputs.filter(input => input.id.startsWith('silicone-text')).forEach(input => {
    if (window.gravureLimiet) window.gravureLimiet.set(input, newLength);
    else input.setAttribute('maxlength', newLength);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

// Emojy Delete 
document.addEventListener('DOMContentLoaded', function() {
    const engravingInputs = document.querySelectorAll('#silicone-text-1, #silicone-text-2, #fabric-text-icons-1-no-qr, #fabric-text-line-1-no-qr, #fabric-text-line-2-no-qr, #fabric-text-line-3-no-qr, #fabric-text-line-4-no-qr');

    engravingInputs.forEach(input => {
        // Universal Emoji Regex jo har tarah ke emoji ko pakad lega
        const emojiRegex = /\p{Emoji_Presentation}|\p{Extended_Pictographic}/gu;

        const cleanInput = (el) => {
            const originalValue = el.value;
            
            // 🔥 FIXED: Replace karte waqt check karein, agar hamare custom 3 icons hain to unhein delete na karein
            const newValue = originalValue.replace(emojiRegex, (match) => {
                if (['©', '®', '™'].includes(match)) {
                    return match; // Hamare icon ko safe rakho
                }
                return ''; // Baqi asli emojis ko delete kar do
            });

            if (originalValue !== newValue) {
                el.value = newValue;

                // Red border dikhana
                el.style.border = "2px solid red";
                setTimeout(() => {
                    el.style.border = "";
                }, 2000);
            }
        };

        // Emoji ko enter hone se pehle hi rokne ke liye
        input.addEventListener('beforeinput', (e) => {
            if (e.data && emojiRegex.test(e.data)) {
                e.preventDefault();
                
                input.style.border = "2px solid red";
                setTimeout(() => {
                    input.style.border = "";
                }, 2000);
            }
        });

        input.addEventListener('input', () => cleanInput(input));
    });
    
    // const interval = setInterval(() => {
    //   const volumeContainer = document.querySelector(".ia-deal-block");
    //   const targetButtons = document.querySelector(".product-form__buttons");

    //   if (volumeContainer && targetButtons) {
    //     targetButtons.parentNode.insertBefore(volumeContainer, targetButtons);
    //     volumeContainer.style.display = 'block';
    //   }

    //   if (volumeContainer) {
    //     setTimeout(() => {
    //       clearInterval(interval);
    //     }, 1000);
    //   }
    // }, 300);
});

// ===============================
// MAAT VERPLICHT KIEZEN
// Bij het laden is bewust geen maat geselecteerd (zie RESET VARIANTS bovenaan),
// alleen voor variant-selects met data-require-choice (instelling per template).
// Hier wordt toevoegen aan winkelwagen geblokkeerd tot elke optie gekozen is.
// Werkt voor elke knop/formulier op de pagina (ook QR-formulier en Enter-toets).
// ===============================
(function () {
  function findSelects(el) {
    const scope = el.closest('product-info, .product, section') || document;
    return scope.querySelector('variant-selects[data-require-choice]');
  }

  function missingOption(selects) {
    if (!selects) return false;
    const groups = selects.querySelectorAll('fieldset');
    if (groups.length) {
      return Array.from(groups).some(fs => {
        const radios = fs.querySelectorAll('input[type="radio"]');
        return radios.length > 0 && !Array.from(radios).some(r => r.checked);
      });
    }
    const radios = selects.querySelectorAll('input[type="radio"]');
    return radios.length > 0 && !Array.from(radios).some(r => r.checked);
  }

  function showMessage(selects) {
    const text = (window.translations && window.translations.chooseSize) || 'Kies uw maat';
    let msg = selects.parentElement.querySelector('.variant-required-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'variant-required-msg';
      msg.setAttribute('role', 'alert');
      msg.style.cssText = 'color:#c62828;font-weight:600;margin:6px 0 0;';
      selects.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = text;
    showPopup(text, selects);
  }

  /* Duidelijke pop-up (geen browser-alert): knop "Maat kiezen" sluit hem en
     scrollt naar de maten. Opmaak: id4all-stijl.css, blok MAAT-POP-UP. */
  function showPopup(text, selects) {
    let box = document.getElementById('maat-popup');
    if (!box) {
      box = document.createElement('div');
      box.id = 'maat-popup';
      box.className = 'maat-popup';
      box.innerHTML =
        '<div class="maat-popup__venster" role="alertdialog" aria-modal="true" aria-labelledby="maat-popup-titel">' +
          '<p id="maat-popup-titel" class="maat-popup__titel"></p>' +
          '<button type="button" class="maat-popup__knop button button--primary"></button>' +
        '</div>';
      document.body.appendChild(box);
      box.addEventListener('click', (e) => { if (e.target === box) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });
    }
    const knop = box.querySelector('.maat-popup__knop');
    box.querySelector('.maat-popup__titel').textContent = text;
    knop.textContent = (window.translations && window.translations.chooseSizeButton) || 'Maat kiezen';
    function close() {
      box.classList.remove('is-open');
      selects.scrollIntoView({ behavior: 'smooth', block: 'center' });
      selects.classList.add('highlighted');
      setTimeout(() => selects.classList.remove('highlighted'), 2500);
      const eerste = selects.querySelector('input[type="radio"]:not([disabled])');
      if (eerste) setTimeout(() => { try { eerste.focus({ preventScroll: true }); } catch (err) {} }, 400);
    }
    knop.onclick = close;
    box.classList.add('is-open');
    setTimeout(() => knop.focus(), 30);
  }

  function guard(e, el) {
    const selects = findSelects(el);
    if (missingOption(selects)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showMessage(selects);
    }
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-form__submit');
    if (btn) guard(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[data-type="add-to-cart-form"]')) guard(e, e.target);
  }, true);

  // Melding weg zodra er een maat gekozen wordt
  document.addEventListener('change', function (e) {
    if (e.target.matches('variant-selects input[type="radio"]')) {
      const msg = e.target.closest('variant-selects').parentElement.querySelector('.variant-required-msg');
      if (msg) msg.remove();
    }
  });
})(); 

// ================= FAST BUNDLE functionality ===================//

(function() {
    // Fast Bundle-hack: draait alleen zolang de app aanwezig is.
    // Na 15 s zonder Fast Bundle-container stopt hij vanzelf (bv. als de app uit staat).
    const fbStart = Date.now();
    const interval = setInterval(() => {
        if (!document.getElementById("rbr-container-element-volume") && Date.now() - fbStart > 15000) {
            clearInterval(interval);
            return;
        }
        // 1. Target the elements
        const volumeContainer = document.getElementById("rbr-container-element-volume");
        const targetButtons = document.querySelector(".product-form__buttons");
        
        // 2. Select the specific elements that have the unwanted inline 'display: none'
        // Add any additional IDs or classes from your screenshot here
        const elementsToClean = document.querySelectorAll(
            ".btns-row, #custom-fields-cont div, #medical-icons-keyboard, #qr-code-phone-generator, #qr-code-text-line-cont, #fabric-icon-text-no-qr-cont, #fabric-text-only-no-qr-cont"
        );

        // 3. Move the volume container if both elements exist
        if (volumeContainer && targetButtons) {
            // Check if it's already moved to prevent repetitive DOM manipulation
            if (volumeContainer.nextElementSibling !== targetButtons) {
                targetButtons.parentNode.insertBefore(volumeContainer, targetButtons);
                volumeContainer.style.display = 'block'; // Ensure it's visible
            }
        }

        // 4. Remove inline 'display: none' from the cleaned elements
        if (elementsToClean.length > 0) {
            elementsToClean.forEach(el => {
                // Check if style attribute exists and contains 'none'
                if (el.getAttribute("style") && el.getAttribute("style").includes("display: none")) {
                    el.style.display = ""; // Clears the inline style
                    if (volumeContainer) volumeContainer.style.display = 'block';
                }
            });
        }

        // Optional: Stop the interval after 10 seconds to save performance
        // if the elements are already found and processed
        // setTimeout(() => clearInterval(interval), 10000); 

    }, 300); // Runs every 300ms
})();

